<template>
  <v-container v-if="agentShifts">
    <v-row>
      <v-col>
        <v-alert v-if="error" color="red" type="warning">{{ error }}</v-alert>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Agent Shifts</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div class="flex">
              <div
                class="table"
                v-for="shift in agentShifts"
                @drop="
                  user.permissions.updateOthers
                    ? onDrop($event, shift.shift.id)
                    : null
                "
                @dragover.prevent
                @dragenter.prevent
                :key="shift.shift.id"
              >
                <div class="header">
                  {{ shift.shift.shift_name }}
                </div>
                <div
                  class="item"
                  draggable="true"
                  v-for="agent in shift.agents"
                  :key="agent.id"
                  @dragstart="startDrag($event, agent)"
                >
                  <div class="flag">
                    <img
                      :src="`https://catamphetamine.gitlab.io/country-flag-icons/3x2/${agent.country_code}.svg`"
                      class="flag"
                    />
                  </div>

                  <div class="agent-details">
                    <span>{{ agent.first_name }}</span>
                    <span>{{ agent.last_name }}</span>
                    <span
                      >🎫 {{ moment(agent.ticket_timestamp).fromNow() }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      user: JSON.parse(localStorage.user),
      shifts: [],
      agents: {},
      dragItem: null,
      error: null,
      interval: null,
      moment: moment,
    };
  },
  created() {
    this.loadData();
    axios
      .get("/api/v1/shifts/list")
      .then((res) => {
        this.shifts = res.data;
      })
      .catch((err) => {
        this.error = err.response.data;
      });
    // 5 sec interval
    this.interval = setInterval(this.loadData, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    loadData() {
      let that = this;
      axios
        .get("/api/v1/agents/list")
        .then((res) => {
          that.agents = res.data.grouped;
        })
        .catch((err) => {
          that.error = err.response.data;
        });
    },
    onDrop(evt, list) {
      let that = this;
      axios
        .post("/api/v1/agents/update-shift", {
          email: this.dragItem.email,
          shift: list,
        })
        .then(() => {
          that.loadData();
          that.error = null;
        })
        .catch((err) => {
          that.error = err.response.data;
        });
    },
    startDrag(evt, item) {
      this.dragItem = item;
    },
  },
  computed: {
    agentShifts() {
      if (!this.shifts) return [];
      if (!this.agents) return [];
      //returns
      let shiftsAndAgents = [];

      this.shifts.forEach((shift) => {
        shiftsAndAgents.push({
          shift,
          agents: this.agents[shift.id],
        });
      });
      return shiftsAndAgents;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.table {
  flex: 1;
  min-height: calc(100vh - 200px);
  height: 150%;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #2b2b2b;
  }
  .header {
    font-weight: bold;
    text-align: center;
    padding: 10px;
    background-color: #9c27b0;
    color: white;
  }
  .item {
    padding: 10px;
    display: flex;
    gap: 2px;
    border: 1px solid #ccc;
    margin: 5px;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.2);
    &:hover {
      background-color: #767676;
    }
  }
}
.agent-details {
  display: flex;
  flex-direction: column;
}

.flag {
  margin-right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    pointer-events: none;
  }
}
</style>
